module.exports = __webpack_public_path__ + "img/advantage3.9fa3a51f.png";